"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EINVALIDHISTORYLENGTH = exports.EINVALIDID = exports.EINVALIDSTEPS = exports.EINVALIDPATHNAME = exports.EINVALIDPATTERN = exports.EMISSINGPATHNAME = exports.EMISSINGPATTERN = exports.EPARAMSINVALID = exports.EPARAMSEMPTY = exports.EPARAMSMISSING = void 0;
var EPARAMSMISSING = 'Missing params when routing';
exports.EPARAMSMISSING = EPARAMSMISSING;
var EPARAMSEMPTY = 'Empty params when routing';
exports.EPARAMSEMPTY = EPARAMSEMPTY;
var EPARAMSINVALID = 'The given params are invalid';
exports.EPARAMSINVALID = EPARAMSINVALID;
var EMISSINGPATTERN = 'Missing pattern when registering a route';
exports.EMISSINGPATTERN = EMISSINGPATTERN;
var EMISSINGPATHNAME = 'Missing pathname';
exports.EMISSINGPATHNAME = EMISSINGPATHNAME;
var EINVALIDPATTERN = 'Invalid type for pattern when registering a route';
exports.EINVALIDPATTERN = EINVALIDPATTERN;
var EINVALIDPATHNAME = 'No matching pattern was found for the given pathname';
exports.EINVALIDPATHNAME = EINVALIDPATHNAME;
var EINVALIDSTEPS = 'The number of steps you have given is invalid';
exports.EINVALIDSTEPS = EINVALIDSTEPS;
var EINVALIDID = 'The given id does not point to any route';
exports.EINVALIDID = EINVALIDID;
var EINVALIDHISTORYLENGTH = 'History of length 0 can not be reset';
exports.EINVALIDHISTORYLENGTH = EINVALIDHISTORYLENGTH;